<div class="linked-badge">
  <fa-icon [icon]="'link'" class="icon"></fa-icon>
  <span class="text">{{ 'DATASELECTION.EDITOR.DISPLAY.LINKED' | translate }}</span>
</div>
